import api from '../../../api/apiService';
import { ENDPOINTS } from '../../../api/endpoints';
import type { ProductivityChartApiResponse } from '../types/productivityChart.types';

type ProductivityChartPayload = {
  ManagerEmployeeCode: string;
  fromDate: string;
  toDate: string;
};

export const getProductivityChart = async (
  payload: ProductivityChartPayload,
): Promise<ProductivityChartApiResponse[]> => {
  console.log(
    'Calling API:',
    ENDPOINTS.TEAM_PRODUCTIVITY_COMPARISON,
  );

  console.log('Payload:', payload);

  try {
    const response = await api.post(
      ENDPOINTS.TEAM_PRODUCTIVITY_COMPARISON,
      payload,
    );

    console.log('Productivity chart API Response:', response);
    console.log('Productivity chart Response Data:', response.data);

    return response.data;
  } catch (error) {
    console.error(
      'Productivity Chart API Error:',
      error,
    );
    throw error;
  }
};